import { Observable } from 'rxjs'
import { filter, startWith, switchMap } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'

import { Component, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'

import { ConfigurationOption } from '../configuration-option'
import { configurationOptionSelectors } from '../configuration-option.selectors'

@Component({
  selector: 'configuration-option-show',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class ConfigurationOptionShowComponent implements OnInit {
  public configurationOption$: Observable<ConfigurationOption>
  public configurationOptionId$: Observable<string>
  public isLoading$: Observable<boolean>

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    this.isLoading$ = this.store
      .select(configurationOptionSelectors.selectIsLoading)
      .pipe(startWith(false))

    this.configurationOptionId$ = this.store
      .select(configurationOptionSelectors.selectIdRouteParam)
      .pipe(filter((id) => Boolean(id)))

    this.configurationOption$ = this.configurationOptionId$.pipe(
      switchMap((configurationOptionId) =>
        this.store.select(
          configurationOptionSelectors.selectById,
          configurationOptionId
        )
      )
    )
  }
}
